// extracted by mini-css-extract-plugin
export default {"p_content":"_9daf25e415"};